@import "tailwindcss";

body {
  color: var(--color-text);
}

@theme {
  --color-primary1: #4A9462;
  --color-primary2: #0B3465;
  --color-secondary1: #C017A2;
  --color-secondary2: #722282;
  --color-background: white;
  --color-background2: #f7f7f7;
  --color-text-color: #545454;
  
  --radius-base: 8px;
  
  --shadow-sidebar: 4px 0 15px rgba(0, 0, 0, 0.1);
  --shadow-box1: 0 4px 12px rgba(0,0,0,0.1);

  --border-1: lightgray;
}

/* Theme */

:root {
  --color-primary-1: #4A9462;
  --color-primary-2: #0B3465;

  --color-secondary-1: #C017A2;
  --color-secondary-2: #722282;
  
  --color-text: #545454;
  
  --color-light: #ffffff;
  --color-dark: #2a2a2a;
  --color-background: #ffffff;
  --color-background-2: #f7f7f7;
  --color-warn: tomato;
  --color-border: lightgray;
  --color-error: tomato;
}
